import React, { useContext, useState } from "react"
import { Layout } from "antd"

import { DefaultHeader, DefaultSider, DefaultContent, DefaultFooter } from "."
import context from "../../utils/context"
import { Loading } from "../../components/custom"

const DefaultLayout = () => {
  const [isCollapsed, collapse] = useState(false)

  const appContext = useContext(context)

  return (
    <Layout>
      <DefaultSider isCollapsed={isCollapsed} />
      <Layout className="site-layout">
        <DefaultHeader isCollapsed={isCollapsed} collapse={collapse} />
        <DefaultContent />
        <DefaultFooter />
      </Layout>
    </Layout>
  )
}

export default DefaultLayout
